import { Fragment, type ReactElement } from 'react';
import { useNavigate } from 'react-router';

import { useUnreadBadge } from '@/hooks/useUnreadNotifications';
import { UNREAD_UNKNOWN } from '@/lib/unread-badge';

import { CompanySwitcher } from './CompanySwitcher';

import { MobileNav } from './MobileNav';
import { CrumbLabel } from './CrumbLabel';
import { usePageChrome } from './page-chrome-context';
import { ThemeToggle } from './ThemeToggle';
import { UserMenu } from './UserMenu';

export function Header(): ReactElement {
  const { breadcrumb } = usePageChrome();
  const unread = useUnreadBadge();
  const navigate = useNavigate();

  return (
    <div className="top">
      <MobileNav />
      <nav className="crumb" aria-label="Ruta de navegación">
        {breadcrumb.map((crumb, i) => (
          <Fragment key={`${crumb.label}-${i}`}>
            {i > 0 && <span className="s">/</span>}
            <CrumbLabel crumb={crumb} />
          </Fragment>
        ))}
      </nav>

      <div className="actions">
        <CompanySwitcher />

        <ThemeToggle />

        <button
          type="button"
          className="iconbtn"
          onClick={() => void navigate('/notificaciones')}
          aria-label={
            unread.unknown
              ? `Notificaciones, ${UNREAD_UNKNOWN.toLowerCase()}`
              : unread.label
                ? `Notificaciones, ${unread.count} sin leer`
                : 'Notificaciones'
          }
          title={unread.unknown ? UNREAD_UNKNOWN : 'Notificaciones'}
        >
          {unread.unknown ? (
            <span className="badge-dot unknown" aria-hidden="true">
              ?
            </span>
          ) : (
            unread.label && (
              <span className="badge-dot" aria-hidden="true">
                {unread.label}
              </span>
            )
          )}
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            aria-hidden="true"
          >
            <path d="M18 8a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
            <path d="M13.7 21a2 2 0 0 1-3.4 0" />
          </svg>
        </button>

        <UserMenu />
      </div>
    </div>
  );
}
